module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        This action requirest authentication through <b>DocuSign</b> <br /><br />\r\n\r\n        You will be redirected to DocuSign for authentication. <br />\r\n        Please use your DocuSign account to login and you will be automatically redirected back to this page    \r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/templates/enquiry/docuSignAuthConsentTemplate.html
// module id = 1950
// module chunks = 0